import { LinkButton } from '@cfra-nextgen-frontend/shared/src/components/ETFButton/ETFLinkButton';
import { Box, SxProps } from '@mui/material';

interface SnackMessageFormProps {
    message: string | React.ReactElement;
    actionBtnText?: string;
    onActionBtnClick?: () => void;
    actionBtnContainerSx?: SxProps;
    actionBtnSx?: SxProps;
    inlineActionBtn?: boolean;
}

const ActionButton = ({
    text,
    onClick,
    containerSx = {},
    actionBtnSx = {},
}: {
    text: string;
    onClick?: () => void;
    containerSx?: SxProps;
    actionBtnSx?: SxProps;
}) => (
    <Box sx={containerSx}>
        <LinkButton sx={{ color: '#3078B5', fontSize: '14px', ...actionBtnSx }} onClick={onClick}>
            {text}
        </LinkButton>
    </Box>
);

export function SnackMessageForm({
    message,
    actionBtnText,
    onActionBtnClick,
    actionBtnContainerSx = {},
    actionBtnSx = {},
    inlineActionBtn = false,
}: SnackMessageFormProps) {
    if (!actionBtnText) {
        return <Box>{message}</Box>;
    }

    const actionButton = (
        <ActionButton
            text={actionBtnText!}
            onClick={onActionBtnClick}
            containerSx={actionBtnContainerSx}
            actionBtnSx={actionBtnSx}
        />
    );

    return (
        <Box>
            <Box>
                {message}
                {inlineActionBtn && actionButton}
            </Box>
            {!inlineActionBtn && actionButton}
        </Box>
    );
}
